import "./PropertyListing.css";
import React, { Fragment, useState } from "react";

import PropertiesContent from "../PropertiesContent/PropertiesContent";
import CommonLoader from "../scripts/CommonLoader";

import InfiniteScroll from "react-infinite-scroll-component";

import { usePublicProperties } from "../scripts/PublicProperties";
import NoDataFound from "../../../components/Common/NoDataFound/NoDataFound";

const PropertyListing = ({ Type, FiltersParams, areFiltersSetToDefault }) => {
  const [Properties, fetchProperties, hasMore] = usePublicProperties(
    Type,
    FiltersParams,
    areFiltersSetToDefault
  );

  // Modal Start
  const [OpenModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseDetailModal = () => setOpenModal(false);
  // Modal End

  return (
    <>
      <InfiniteScroll
        dataLength={Properties.length}
        next={fetchProperties}
        hasMore={hasMore}
        loader={<CommonLoader />}
        scrollThreshold={0.9}
        style={{ overflow: "inherit" }}
      >
        <div className="row">
          {Properties &&
            Properties.map((item, index) => (
              <PropertyCard
                key={item.id}
                tab={"public"}
                type={Type}
                property={item}
                handleOpenModal={handleOpenModal}
              />
            ))}
        </div>
      </InfiniteScroll>
      {!hasMore && Properties?.length === 0 ? (
        <Fragment>
          <div className="properties-custom-nothing-container">
            <NoDataFound />
          </div>
        </Fragment>
      ) : (
        ""
      )}
    </>
  );
};

function PropertyCard({ type, property, handleOpenModal, tab }) {
  return (
    <PropertiesContent
      type={type}
      property={property}
      tab={tab}
      key={0}
      CurrencySettings={{
        country: "Pakistan",
        currency: "PKR",
        currencyFormat: "numeral",
      }}
      handleOpenModal={handleOpenModal}
    />
  );
}

export default PropertyListing;
